document.addEventListener('DOMContentLoaded', function() {
    var firstInput = document.querySelector('.pp_input[target_txt="first-image"]');
    var secondInput = document.querySelector('.pp_input[target_txt="second-image"]');
    
    firstInput.addEventListener('input', function() {
        updateCardImageClass('first_card-img', this.value);
    });

    secondInput.addEventListener('input', function() {
        updateCardImageClass('second_card-img', this.value);
    });

    function updateCardImageClass(cardId, inputValue) {
        var cardElement = document.getElementById(cardId);
        // Entfernen Sie zuerst alle vorhandenen Klassen, die mit "A" bis "Z" und "А" bis "Я" beginnen
        for (var i = 65; i <= 90; i++) {  // ASCII-Codes für A bis Z
            var letter = String.fromCharCode(i);
            cardElement.classList.remove(letter);
        }
        for (var i = 1040; i <= 1071; i++) {  // Unicode-Codes für А bis Я
            var cyrillicLetter = String.fromCharCode(i);
            cardElement.classList.remove(cyrillicLetter);
        }

        // Fügen Sie die Klasse basierend auf dem eingegebenen Wert hinzu
        cardElement.classList.add(inputValue.toUpperCase());
    }
});